//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['title'],
  data() {
    return {
      breadList: [], // 路由集合
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    },
  },
  mounted() {},
  computed: {
    // 面包屑导航只显示设置了title属性的项
    breads() {
      return this.breadList.filter((item) => {
        return item.meta.title
      })
    },
  },
  methods: {
    isHome(route) {
      return route.name === 'Home'
    },
    getBreadcrumb() {
      let matched = this.$route.matched
      // if (!this.isHome(matched[0])) {
      //   matched = [{ path: "/", meta: { title: "首页" } }].concat(matched);
      // }
      this.breadList = matched
    },
    /**
     * @descripttion: 返回
     * @Author: juanjuanhui
     * @Date: 2021-12-11 21:57:04
     */
    handleBack() {
      this.$router.go(-1)
    },
  },
  created() {
    this.getBreadcrumb()
  },
}
